export default "__VITE_ASSET__ecbc5356__"